import React from 'react';
import { TabbedView as TabView } from 'components/shared/TabbedView';
import { TABBEDVIEW } from './roles';

/*::
type Props = {
  children?: Array<React.ReactChild>,
  onSelect: () => void,
  selectedIndex: number,
}
*/

const TabbedView = ({ children, onSelect, selectedIndex } /*: Props */) => {
  return (
    <TabView onSelect={onSelect} selectedIndex={selectedIndex}>
      {children}
    </TabView>
  );
};

TabbedView.role = TABBEDVIEW;

export default TabbedView;
